import { render, staticRenderFns } from "./marketing-order.vue?vue&type=template&id=b2a4b550"
import script from "./marketing-order.vue?vue&type=script&lang=js"
export * from "./marketing-order.vue?vue&type=script&lang=js"
import style0 from "./marketing-order.vue?vue&type=style&index=0&id=b2a4b550&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports